import styled from 'styled-components';
import { Button } from '@mui/material';
import { Icon } from 'components/ui';

const MuiMenuButton = styled(({ label, icon, action, variant, ...props }) => (
  <Button
    {...props}
    size="medium"
    variant={variant}
    color="primary"
    onClick={(e) => {
      e.stopPropagation();
      if (action) {
        action();
      }
    }}
    startIcon={<Icon icon={icon} style={{ fontSize: '16px' }} />}
  >
    {label}
  </Button>
))`
  margin: 0 16px !important;
  justify-content: flex-start !important;
`;

export default MuiMenuButton;
